import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState, Icon } from '@knockrentals/knock-shared-web-v2';

export const DEFAULT_DESCRIPTION = 'Please try again later.';

const ErrorState = ({ description = DEFAULT_DESCRIPTION, title }) => (
  <EmptyState>
    <Icon color="denim.600" name="component-alert-error" size={48} />
    <EmptyState.Title>{title}</EmptyState.Title>
    <EmptyState.Description>{description}</EmptyState.Description>
  </EmptyState>
);

ErrorState.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};

export default ErrorState;
